var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"radio-box",class:{ disabled: _vm.disabled }},_vm._l((_vm.options),function(opt){return _c('li',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(opt.tooltip),expression:"opt.tooltip"}],key:opt.value,class:{
      'radio-cell': true,
      active: opt.value === _vm.value,
      disabled: _vm.disabled
    },style:(opt.style),attrs:{"tabindex":_vm.disabled ? -1 : 0},on:{"click":function($event){return _vm.select(opt.value)}}},[_vm._v("\n    "+_vm._s(opt.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }